import { useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_ALL_PRESTACIONES, GET_ALL_PAQUETES } from "../../Querys/prestaciones/querys";
import Box from '@mui/material/Box';
import { Grid } from '@material-ui/core';
import TablePrestacion from "./TablePrestacion";
import { Benefit } from '../../interfaces/Benefit.interface';
import { PrestacionInfoCard } from "./PrestacionInfoCard";
import SearcherTablePrestacion from "./SearcherTablePrestacion";
import Loading from "../Loading";
import { stopGlobalLoading } from "../../context/PrestacionesContext/Actions";
import PrestacionContext from '../../context/PrestacionesContext/PrestacionContext';

type StatusFilter = 'todas' | 'activas' | 'inactivas';

const BodyPrestacion = ({ viewSquare, viewList, infoImg }: any) => {
	const [filteredBenefits, setfilteredBenefits] = useState<Benefit[]>([]);
	const [initialBenefits, setInitialBenefits] = useState<Benefit[]>([]);
	const [statusFilter, setStatusFilter] = useState<StatusFilter>('todas');
	const { dispatch } = useContext(PrestacionContext);
	const { data: prestacionesInfo, loading, refetch } = useQuery(GET_ALL_PRESTACIONES);
	const { data: paquetesData } = useQuery(GET_ALL_PAQUETES);
	const paquetes: any[] = paquetesData?.GET_ALL_PAQUETES ?? [];

	const allBenefits = useMemo(() => {
		return prestacionesInfo?.GET_ALL_PRESTACIONES || [];
	}, [prestacionesInfo]);

	useEffect(() => {
		if (!loading && prestacionesInfo) {
			stopGlobalLoading(dispatch);
		}

		let listToProcess = [...allBenefits];
		if (Object.keys(infoImg).length > 0) {
			const img = infoImg as { idPrestacion: number, URL: string };
			listToProcess = listToProcess.map(prestacion => {
				if (prestacion.id == img.idPrestacion) {
					return { ...prestacion, URL: img.URL };
				}
				return prestacion;
			});
		}
		listToProcess.sort((a: any, b: any) => a.Titulo.localeCompare(b.Titulo));
		setfilteredBenefits(listToProcess);
		setInitialBenefits(listToProcess);
	}, [allBenefits, infoImg, loading, dispatch]);

	const displayedBenefits = useMemo(() => {
		if (statusFilter === 'activas') return filteredBenefits.filter((p: any) => p.Activa === 'Activo');
		if (statusFilter === 'inactivas') return filteredBenefits.filter((p: any) => p.Activa !== 'Activo');
		return filteredBenefits;
	}, [filteredBenefits, statusFilter]);

	if (loading) {
		return <Loading />;
	}
	return (
		<>
			<Box p={2} >
				<div className="containerBtnFindFilter">
					<div>
						<SearcherTablePrestacion
							initState={initialBenefits}
							setState={setfilteredBenefits}
							stateInitial={initialBenefits}
							label={"Buscar por prestación"}
							fields={['titulo']}
							width={400}
						/>
					</div>
					<div style={{ display: 'flex', gap: 8 }}>
						{(['todas', 'activas', 'inactivas'] as StatusFilter[]).map((f) => (
							<div
								key={f}
								className={`btnViewMode ${statusFilter === f ? 'active' : ''}`}
								onClick={() => setStatusFilter(f)}
							>
								<span style={{ textTransform: 'capitalize' }}>{f}</span>
							</div>
						))}
					</div>
				</div>

				{displayedBenefits.length > 0 ? (
					viewSquare ? (
						<Grid className="infoPrestacion">
							<Grid className="exCont">
								{displayedBenefits.map((prestacion: any) => (
									<PrestacionInfoCard
										key={prestacion.id}
										prestacion={prestacion}
										paquetes={paquetes}
									/>
								))}
							</Grid>
						</Grid>
					) : viewList ? (
						<Grid >
							<TablePrestacion
								prestaciones={displayedBenefits}
								paquetes={paquetes}
							/>
						</Grid >
					) : null
				) : (
					<Grid container justify="flex-start" >
						<span>{initialBenefits.length === 0 ? 'Aún no tienes prestaciones registradas' : 'Sin resultados para el filtro seleccionado.'}</span>
					</Grid>
				)}
			</Box>
		</>
	);
}

export default BodyPrestacion;